import { RANGES } from '../../constants';

/**
 * This utility has been taken/borrowed out of the K1 url utility package because we
 * want to remove all of our dependencies to K1.
 */
export class UrlUtility {
  constructor() {
    this.DEFAULT_COUNTRY = 'se';
    this.DEFAULT_LANGUAGE = 'sv';
    this.DEFAULT_UI_PLATFORM = 'irw';
  }

  getAppInfo = () => {
    if (this._appInfo) {
      return this._appInfo;
    }

    const query = this.getCombinedQuery();

    let country = this.DEFAULT_COUNTRY;
    let language = this.DEFAULT_LANGUAGE;

    if (query.locale) {
      const locale = query.locale.split('_');

      if (
        locale.length > 1 &&
        locale[0].length === 2 &&
        locale[1].length === 2
      ) {
        country = locale[1].toLowerCase();
        language = locale[0].toLowerCase();
      }
    }

    this._appInfo = {
      country: country,
      language: language,
      uiPlatform: query.uiPlatform || this.DEFAULT_UI_PLATFORM,
      storeId: query.storeId || null,
      applicationName: this.getApplicationName() || null,
      seriesGallery: {
        applications: query.applications ? query.applications.split(',') : [],
        defaultApplication: query.defaultApplication || null,
      },
    };
    return this._appInfo;
  };

  getCombinedQuery = () => {
    return Object.assign(this.getSearchQuery(), this.getHashQuery());
  };

  getApplicationName = () => {
    const defaultApp = RANGES.BROR.toLowerCase();

    const match = document.location.href.match(
      /\/(bror|jonaxel|boaxel|aurdal|ivar|elvarli)\//i
    );
    return match ? match[1] : defaultApp;
  };

  getSearchQuery = () => {
    const search = window.location.search
      ? window.location.search.substring(1)
      : '';

    return this.parseQueryString(search);
  };

  getHashQuery = () => {
    const hash = window.location.hash
      ? window.location.hash.split('?').reverse()[0]
      : '';
    return this.parseQueryString(hash);
  };

  parseQueryString = queryString => {
    const variables = queryString.split('&');
    const query = {};

    const iterator = this.createForOfIteratorHelper(variables);
    let step;

    try {
      for (iterator.s(); !(step = iterator.n()).done; ) {
        const variable = step.value;

        if (variable) {
          const pair = variable.split('=');
          query[pair[0]] = pair[1];
        }
      }
    } catch (err) {
      iterator.e(err);
    } finally {
      iterator.f();
    }

    return query;
  };

  createForOfIteratorHelper = (o, allowArrayLike) => {
    var it;
    if (typeof Symbol === 'undefined' || o[Symbol.iterator] == null) {
      if (
        Array.isArray(o) ||
        (it = this.unsupportedIterableToArray(o)) ||
        (allowArrayLike && o && typeof o.length === 'number')
      ) {
        if (it) o = it;
        let i = 0;
        const F = function F() {};
        return {
          s: F,
          n: function n() {
            if (i >= o.length) return { done: true };
            return { done: false, value: o[i++] };
          },
          e: function e(e) {
            throw e;
          },
          f: F,
        };
      }
      throw new TypeError(
        'Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
      );
    }
    let normalCompletion = true,
      didErr = false,
      err;
    return {
      s: function s() {
        it = o[Symbol.iterator]();
      },
      n: function n() {
        const step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function e(e2) {
        didErr = true;
        err = e2;
      },
      f: function f() {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      },
    };
  };

  unsupportedIterableToArray = (o, minLen) => {
    if (!o) return;
    if (typeof o === 'string') return this.arrayLikeToArray(o, minLen);
    let n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === 'Object' && o.constructor) n = o.constructor.name;
    if (n === 'Map' || n === 'Set') return Array.from(o);
    if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return this.arrayLikeToArray(o, minLen);
  };
}
